import { Injectable }         from '@angular/core';
import { Http, Response }     from '@angular/http';
import { Observable }         from 'rxjs/Observable';
import { ConfigService }      from '../configuracion/config.service';
import { RequestBaseService } from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class EjecucionActividadService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'ejecucion-actividad'].join('/');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ejecucion-actividad/ejecucion-actividad.service.ts